import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import * as _ from 'lodash';
import { ModalsService } from 'app/shared/services/modals.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';

@AutoUnsubscribe()
@Component({
  selector: 'gdpr-agreement-component',
  templateUrl: './gdpr-agreement.component.html',
  styleUrls: ['./gdpr-agreement.component.scss'],
})
export class GdprAgreementComponent implements OnInit {
  public agreed: boolean;
  public name: string;
  public clickedOnLink: boolean;
  public susbscriptions: Array<any>;

  constructor(
    public modalsService: ModalsService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public sharedService: SharedService,
    public userService: UserService
  ) {
    this.agreed = false;
    this.name = '';
    this.clickedOnLink = false;
    this.susbscriptions = [];
  }

  ngOnInit() {
    this.clickedOnLink = false;
  }

  ngOnDestroy() {}

  acceptGDPR() {
    if (!this.agreed) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('PLEASE_CHECK_THE_BOX'), 'error');
    } else if (this.sharedService.isEmpty(this.name)) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('PLEASE_ENTER_YOUR_NAME'), 'error');
    } else {
      this.susbscriptions.push(
        this.httpService.post('vdsp_ws/acceptGDPR', { name: this.name }).subscribe(
          (response: any) => {
            this.modalsService.hideModal();
            this.susbscriptions.push(
              this.httpService.post('networks_management/getCurrentNetworkData').subscribe(
                (response: any) => {
                  this.userService.networkData = _.cloneDeep(response);
                },
                (error: any) => {
                  this.sharedService.showErrorFlashMessage();
                }
              )
            );
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
          }
        )
      );
    }
  }
}
